import { render } from "./RecipeIngredients.vue?vue&type=template&id=5b8c8d84"
import script from "./RecipeIngredients.vue?vue&type=script&lang=js"
export * from "./RecipeIngredients.vue?vue&type=script&lang=js"

import "./RecipeIngredients.vue?vue&type=style&index=0&id=5b8c8d84&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__